// Thin helpers that wrap return-memo PDF downloads with the backend
// "I printed a memo, please take this order off the Returns Overdue list"
// ping. Centralising this prevents drift — the same flag fires whether
// you click a single Download on the order sheet OR bulk-print from the
// dashboard OR bulk-print from the Logistics page.
//
// Failure of the ping is non-fatal: the PDF already downloaded, the user
// got what they wanted. We just log and move on.
import { api } from "./api";
import { downloadReturnChallanPDF, downloadBulkChallanPDF } from "./pdf";

async function flagMemoDownloaded(orderId) {
  if (!orderId) return;
  try {
    await api.post(`/orders/${orderId}/return-memo-downloaded`);
  } catch {
    /* non-fatal — PDF already saved */
  }
}

// Single-order return memo. Downloads first, then flags the order so the
// Returns Overdue filter drops it.
export async function downloadReturnMemoAndFlag(order) {
  try {
    await downloadReturnChallanPDF(order);
  } finally {
    await flagMemoDownloaded(order?.id);
  }
}

// Bulk return memos. Runs the bulk PDF (kind='return' pre-set), then
// flags every order in the batch. The flags fire in parallel — we don't
// block on them.
export async function downloadBulkReturnMemosAndFlag(orders, opts = {}) {
  try {
    await downloadBulkChallanPDF(orders, { ...opts, kind: "return" });
  } finally {
    await Promise.all((orders || []).map((o) => flagMemoDownloaded(o?.id)));
  }
}
